const initialState = {
    mainType: "",
    color: "",
    shape: "",
    size: "",
    agacCali: "",
    yaprakTipi: "",
    yaprakSekli: "",

}

function setAuthReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_MAINTYPE":
            return { ...state, mainType: action.mainType }
        case "SET_COLOR":
            return { ...state, color: action.color }
        case "SET_SHAPE":
            return { ...state, shape: action.shape }
        case "SET_SIZE":
            return { ...state, size: action.size }
        case "SET_AGACCALI":
            return { ...state, agacCali: action.agacCali }
        case "SET_YAPRAKTIPI":
            return { ...state, yaprakTipi: action.yaprakTipi }
        case "SET_YAPRAKSEKLI":
            return { ...state, yaprakSekli: action.yaprakSekli }
        default:
            return state
    }
}

export default setAuthReducer